import { Breadcrumb, Table, Menu, Image, Row, Col, Button, Modal, Upload, message, ConfigProvider, Tabs, Typography, Checkbox } from 'antd';
import React, { useEffect, useState, useRef, useContext } from 'react';
import axios from 'axios';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { EditOutlined, ExclamationCircleFilled, PlusOutlined } from '@ant-design/icons';
import Label_language from '../language';
const { confirm } = Modal;
const { Title, Paragraph, Text, Link } = Typography;
const label_language = Label_language.cramschool.children
const AdminMakeUpCourseManage = () => {
    return (
        <>
            <Row gutter={[8, 8]} justify={'end'}>
                <Col>
                    <Button className='example' style={{ backgroundColor: '#FdF9C9', display: "inline-flex", alignItems: "center" }} icon={<PlusOutlined />}>新增補課</Button>
                </Col>
                <Col span={24}>
                    <Table columns={[{
                        title: '補課日期',
                        dataIndex: 'week'
                    }, {
                        title: '補課時間',
                        dataIndex: 'content'
                    }, {
                        title: '補課學生',
                        dataIndex: 'content'
                    }, {
                        title: '補課原因',
                        dataIndex: 'content'
                    }, {
                        title: '補課教室',
                        dataIndex: 'content'
                    }]}></Table>
                </Col>
            </Row>
        </>
    )
}
export default AdminMakeUpCourseManage;